import {IOwnProps} from './model';
import View from './view';
import React, {useCallback, useState} from 'react';

export const AcceptorDataCard = (props: IOwnProps) => {
  const {isCloseable = false, isOpenInitially = false} = props;
  const [isActive, setActiveState] = useState<boolean>(!isCloseable ? true : isOpenInitially);
  const toggle = useCallback(() => {
    setActiveState((state) => !state);
  }, [setActiveState]);
  const viewProps = {
    ...props,
    toggle,
    isActive,
  };
  return <View {...viewProps} />;
};
